import { Box, TextField, Button, Select, MenuItem, TableContainer, Table, TableHead, TableBody, TableCell, TableRow, FormControl, Stack, Pagination } from '@mui/material'
import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { menuActive } from 'store/menuSlice'
import deleteIcon from '../../assets/icons/delete.svg'
import editIcon from '../../assets/icons/edit.svg'
import { useNavigate } from 'react-router-dom'
import * as api from '../services/api'
import CustomizedModal from 'components/modal/CustomizedModal'
import Loader from 'components/Loader'

function InterpretationManager() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)

    const [search, setSearch] = useState('')
    const [program, setProgram] = useState('')
    const [programList, setProgramList] = useState([])

    const [criteria, setCriteria] = useState([])
    const [criteriaAll, setCriteriaAll] = useState([])

    const [numPage, setNumPage] = useState(5)
    const [page, setPage] = useState(1)
    const [maxPage, setMaxPage] = useState(1)
    const [showList, setShowList] = useState([])

    const [modalDelete, setModalDelete] = useState(false)
    const [dataDelete, setDataDelete] = useState({ healthcheck_code: null, healthcheck_name: null, checklist_group_code: null })

    useEffect(() => {
        dispatch(menuActive('จัดการเกณฑ์แปรผล'))
        checklist()
    }, [])

    useEffect(() => {
        findCriteria()
        setPage(1)
    }, [numPage])

    useEffect(() => {
        let start = page * numPage - numPage
        setShowList(criteria.slice(start, start + numPage))
    }, [page, criteria])

    const handlePageChange = (event, page) => {
        setPage(page)
    }

    const handleClickSearch = () => {
        if (search === '') {
            const filteredItems = criteriaAll.filter((item) =>
                item.checklist_group_code.toLowerCase().includes(program.toLowerCase())
            )
            setShowList(filteredItems)
            setCriteria(filteredItems)
            setMaxPage((Math.ceil(filteredItems.length / numPage)))
        } else {
            const filteredItems = criteriaAll.filter((item) =>
                item.healthcheck_name.toLowerCase().includes(search.toLowerCase()) &&
                item.checklist_group_code.toLowerCase().includes(program.toLowerCase())
            )
            setShowList(filteredItems)
            setCriteria(filteredItems)
            setMaxPage((Math.ceil(filteredItems.length / numPage)))
        }
    }

    const handleClickProgram = (e) => {
        if (e.target.value === 'null') {
            setProgram('')
            const filteredItems = criteriaAll.filter((item) =>
                item.healthcheck_name.toLowerCase().includes(search.toLowerCase())
            )
            setShowList(filteredItems)
            setCriteria(filteredItems)
            setMaxPage((Math.ceil(filteredItems.length / numPage)))
        } else {
            setProgram(e.target.value)
            const filteredItems = criteriaAll.filter((item) =>
                item.healthcheck_name.toLowerCase().includes(search.toLowerCase()) &&
                item.checklist_group_code.toLowerCase().includes(e.target.value.toLowerCase())
            )
            setShowList(filteredItems)
            setCriteria(filteredItems)
            setMaxPage((Math.ceil(filteredItems.length / numPage)))
        }
    }

    const checklist = async () => {
        setLoading(true)
        let res = await api.checklist()
        setLoading(false)
        if (res) {
            if (res['data']['code'] == '200') {
                let data = res['data']['data']

                let list = []
                for (let i = 0; i < data.length; i++) {
                    if (data[i]) {
                        list.push({
                            key: data[i]['checklist_group_code'],
                            name: data[i]['checklist_group_name']
                        })
                    }
                    const unique = [...new Map(list.map((m) => [m.key, m])).values()] //กรองชื่อซ้ำ
                    setProgramList(unique)
                }
            } else {
                //alert(res['data']['message']);
            }
        } else {
            alert("ไม่ตอบสนอง");
        }
    }

    const findCriteria = async () => {
        setLoading(true)
        let res = await api.fintCriteria()
        setLoading(false)
        if (res) {
            if (res['data']['code'] == '200') {
                let data = res['data']['data']
                setCriteria(data)
                setCriteriaAll(data)
                setMaxPage((Math.ceil(data.length / numPage)))
            } else {
                //alert(res['data']['message']);
            }
        } else {
            alert("ไม่ตอบสนอง");
        }
    }

    const deleteCriteria = async () => {
        setLoading(true)
        let res = await api.deleteCriteria(dataDelete.healthcheck_code, dataDelete.checklist_group_code)
        setLoading(false)
        setModalDelete(false)
        if (res) {
            if (res['data']['code'] == '200') {
                //alert(res['data']['message'])
                findCriteria()
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert("ไม่ตอบสนอง");
        }
    }


    const handleClickEdit = (item) => {
        // console.log(item)
        navigate('/interpretationEdit', { state: { list: item, option: programList } })
    }
    const handleClickDelete = (healthcheck_code, healthcheck_name, checklist_group_code) => {
        setDataDelete({ healthcheck_code, healthcheck_name, checklist_group_code })
        setModalDelete(true)
    }

    return (
        <>
            <Loader loading={loading} />
            {modalDelete ?
                <CustomizedModal
                    onClose={() => { setModalDelete(false) }}
                    apiCall={deleteCriteria}
                    confirmMessage={`ต้องการลบ "${dataDelete.healthcheck_name}" หรือไม่?`}
                    confirmButtonText={`ยืนยัน`}
                />
                : null
            }
            <Box sx={{ display: 'grid', gridGap: '10px' }}>
                <Box sx={{
                    fontWeight: 600,
                    color: "#478F96",
                    "@media (max-width: 800px)": {
                        textAlign: "center",
                    },
                }}>จัดการเกณฑ์แปลผล</Box>
                <Box>จัดการค่ามาตรฐานของการแปลผลสุขภาพในแต่ละค่า</Box>

                <Box sx={{
                    border: '1px solid #478F96',
                    borderRadius: '10px',
                    padding: '20px',
                    display: 'grid',
                    gridGap: '10px',
                    "@media (max-width: 800px)": {
                        padding: '10px'
                    },
                }}>
                    <Box sx={{ fontWeight: 600 }}>ค้นหาค่าการตรวจสุขภาพ</Box>

                    <Box sx={{
                        border: '1px solid #478F96',
                        borderRadius: '10px',
                        display: 'flex',
                        padding: '5px'
                    }}>
                        <TextField
                            fullWidth
                            variant="standard"
                            sx={{
                                ...InputCSS
                            }}
                            InputProps={{
                                disableUnderline: true,
                            }}
                            placeholder="ค้นหาด้วยชื่อ"
                            value={search}
                            onChange={(e) => { setSearch(e.target.value) }}
                        />
                        <Button variant='contained' onClick={() => { handleClickSearch() }}>ค้นหา</Button>
                    </Box>

                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Select
                            size="small"
                            sx={{ ...SelectCss }}
                            value={program || 'null'}
                            onChange={(e) => { handleClickProgram(e) }}
                        >
                            <MenuItem value='null'>เลือกโปรแกรม</MenuItem>
                            {programList.map((i, idx) => (
                                <MenuItem key={idx} value={i['key']}>{i['name']}</MenuItem>
                            ))}
                        </Select>
                        {/* <Button variant='contained' onClick={() => { navigate('/interpretationAdd', { state: { option: programList, list: criteriaAll } }) }}>เพิ่มการแปลผล</Button> */}
                    </Box>

                    <Box sx={{
                        overflow: 'auto'
                    }}>
                        <TableContainer>
                            <Table>
                                <TableHead sx={{ backgroundColor: '#C8EBEB' }}>
                                    <TableRow>
                                        <TableCell>ชื่อค่าการตรวจ</TableCell>
                                        <TableCell align="center" sx={{ width: '100px' }}>จัดการ</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {showList.length > 0 ? (
                                        showList.map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{item['healthcheck_name']}</TableCell>
                                                <TableCell align="center" sx={{ width: '100px' }}>
                                                    <img
                                                        src={editIcon}
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => { handleClickEdit(item) }}
                                                    />
                                                    <img
                                                        src={deleteIcon}
                                                        style={{ cursor: 'pointer', marginLeft: '10px' }}
                                                        onClick={() => { handleClickDelete(item['healthcheck_code'], item['healthcheck_name'], item['checklist_group_code']) }}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    )
                                        :
                                        (
                                            <TableRow>
                                                <TableCell colSpan='2'>
                                                    <Box sx={{ textAlign: 'center' }}>ไม่มีข้อมูล</Box>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>

                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        margin: 2
                    }}>
                        <Box sx={{ width: '100px' }}>
                            <FormControl fullWidth>
                                <Select
                                    value={numPage}
                                    onChange={(e) => {
                                        const {
                                            target: { value },
                                        } = e;
                                        setNumPage(value)
                                    }}
                                    size='small'
                                    sx={{ width: '100px', fontSize: '14px' }}
                                >
                                    <MenuItem value={5}>5</MenuItem>
                                    <MenuItem value={10}>10</MenuItem>
                                    <MenuItem value={20}>20</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>
                        <Stack spacing={2}>
                            <Pagination
                                count={maxPage}
                                page={page}
                                onChange={handlePageChange}
                                shape="rounded"
                                color="primary"
                            />
                        </Stack>
                    </Box>

                </Box>
            </Box>
        </>
    )
}

export default InterpretationManager

const InputCSS = {
    padding: '5px',
    border: 'none',
    '&.MuiInputBase-root': {
        border: 'none'
    },
    '&.MuiInputBase-root:focus': {

    }
}

const SelectCss = {
    backgroundColor: '#C8EBEB',
    border: 'none',
    '.MuiOutlinedInput-notchedOutline': {
        borderColor: '#C8EBEB',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#C8EBEB',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#C8EBEB',
    },
}